import { KatButton, KatCard, KatInputGroup } from '@amzn/katal-react';
import React from 'react';

export const CustomArrayFieldTemplate = (props: any) => {

    function getButton(label: string, clickFunction: any) {
        return (
                        <KatButton
                            disabled={props.disabled || props.readonly}
                            className="primary"
                            label={label}
                            size="small"
                            onClick={clickFunction}
                        />
        );
    }

    return (
      <div>
         {props.items && props.items.map((element: any) => (
            <div key={element.key} className={element.className}>

                { (element.children.props.schema.type !== "object") &&
                    <KatInputGroup>
                        {getButton("Remove", element.onDropIndexClick(element.index))}
                        {element.children}
                    </KatInputGroup>
                }
                { (element.children.props.schema.type === "object") &&
                    <KatCard variant="warning">
                        {getButton("Remove", element.onDropIndexClick(element.index))}
                        {element.children}
                    </KatCard>
                }
            </div>
         ))}

         {props.canAdd &&
            <p className="col-xs-3 col-xs-offset-9 array-item-add text-right">
                {getButton("Add", props.onAddClick)}
            </p>
        }
        </div>
    );
}
